import React, { useContext, useState } from 'react';
import lodashGet from 'lodash/get';
import { apiHolder, apis } from 'api';
import classnames from 'classnames/bind';
import { Checkbox, Input } from 'antd';
import message from '@web-common/components/UI/Message/SiriusMessage';
import { useObservable } from 'rxjs-hooks';
import { map, take } from 'rxjs/operators';
import SearchIcon from '@web-common/components/UI/Icons/svgs/SearchSvg';
import Modal from '@web-common/components/UI/Modal/SiriusModal';
import style from './chatForward.module.scss';
import { Context as MessageContext, MessageAction } from '../store/messageProvider';
import { UserItem, TeamItem, ChatForwardP2PItem, ChatForwardTeamItem } from './chatForwardItem';
import { ChatForwardFooter } from './chatForwardFooter';
import { ReactComponent as CloseIcon } from '@/images/icons/close_modal.svg';
import { getIn18Text } from 'api';
const realStyle = classnames.bind(style);
const systemApi = apiHolder.api.getSystemApi();
const nimApi = apiHolder.api.requireLogicalApi('NIM');
const discussApi = apiHolder.api.requireLogicalApi(apis.imDiscussApiImpl);
const contactApi = apiHolder.api.requireLogicalApi('contactApi');
const MODAL_TEXT = {
    sendText: {
        titleText: getIn18Text('FASONGDAO'),
        okText: getIn18Text('FASONG'),
    },
    forwardText: {
        titleText: getIn18Text('ZHUANFADAO'),
        okText: getIn18Text('ZHUANFA'),
    },
    shareText: {
        titleText: getIn18Text('FENXIANGDAO'),
        okText: getIn18Text('FENXIANG'),
    },
};
const ChatForwardSessionList = props => {
    const { sessionList, onChange, checkedSessionMap } = props;
    const [searchKey, setSearchKey] = useState('');
    const onTextChange = e => {
        setSearchKey(e.target.value);
    };
    return (React.createElement("div", { className: realStyle('column', '  operationPanel') },
        React.createElement("div", { className: realStyle('searchWrapper') },
            React.createElement(Input, { value: searchKey, onChange: onTextChange, placeholder: getIn18Text('SOUSUOHUIHUA'), prefix: React.createElement(SearchIcon, { className: "dark-invert" }), type: "text", className: realStyle('search') })),
        React.createElement("div", { className: realStyle('optionsName') }, getIn18Text('ZUIJINHUIHUA')),
        React.createElement("ul", { className: `ant-allow-dark ${realStyle('sessionList')}` }, sessionList.map(item => {
            if (item.scene === 'p2p') {
                return (React.createElement(ChatForwardP2PItem, { to: item.to, keyword: searchKey, onchange: onChange },
                    React.createElement(Checkbox, { className: realStyle('checkbox'), checked: checkedSessionMap.includes(item.id) })));
            }
            return (React.createElement(ChatForwardTeamItem, { to: item.to, keyword: searchKey, onchange: onChange },
                React.createElement(Checkbox, { className: realStyle('checkbox'), checked: checkedSessionMap.includes(item.id) })));
        }))));
};
const CheckedSessionList = props => {
    const { onChange, checkedSessionMap } = props;
    return (React.createElement("div", { className: realStyle('column') },
        React.createElement("p", { className: realStyle('checkedCount') },
            getIn18Text('YIXUAN\uFF1A'),
            checkedSessionMap.length,
            "/10"),
        React.createElement("ul", { className: realStyle('checkedUserWrapper') }, checkedSessionMap.map(item => {
            const to = item.replace(/^p2p-|^team-/, '');
            return (React.createElement("li", { key: item },
                /^p2p/.test(item) && React.createElement(UserItem, { id: to }),
                /^team/.test(item) && React.createElement(TeamItem, { id: to }),
                React.createElement("span", { onClick: e => {
                        onChange(item);
                    }, className: `${realStyle('removeIcon')} remove-icon` })));
        }))));
};
const ChatForward = props => {
    var _a;
    const { msgs, type = 'forwardText', onVisibleChange, onForwardSuccess } = props;
    const { dispatch: dispatchMsg } = useContext(MessageContext);
    const { sendTextMessage } = useContext(MessageContext);
    const $sessionlist = useObservable(() => {
        const $sessionStream = nimApi.sessionStream.getSubject();
        return $sessionStream.pipe(map(list => list.filter(item => !/lx_/.test(item.to)))).pipe(take(1));
    }, []);
    const [checkedSessionMap, setCheckedSession] = useState([]);
    const onChange = id => {
        setCheckedSession(sessions => {
            const sessionSet = new Set(sessions);
            if (sessionSet.has(id)) {
                sessionSet.delete(id);
            }
            else if (sessionSet.size < 10) {
                sessionSet.add(id);
            }
            return [...sessionSet];
        });
    };
    const [visible, setVisible] = useState(true);
    const [confirmloading, setConfirmloading] = useState(false);
    const onCancel = () => {
        onVisibleChange(false);
    };
    const sendForwardMsg = async () => {
        var _a, _b, _c;
        if (!checkedSessionMap.length) {
            return message.error(`请选择${MODAL_TEXT[type].okText}session`);
        }
        setConfirmloading(true);
        let success = true;
        if (type === 'sendText') {
            await Promise.all(checkedSessionMap.map(async (session) => {
                const forwardedMsg = (await sendTextMessage(Object.assign(Object.assign({}, msgs), { scene: /^p2p/.test(session) ? 'p2p' : 'team', to: session.replace(/^p2p-|^team-/, '') })));
                return forwardedMsg;
            }));
        }
        else if (type === 'forwardText') {
            await Promise.all(checkedSessionMap.map(async (session) => {
                await Promise.all(msgs.map(async (msg) => {
                    const forwardedMsg = (await nimApi.excute('forwardMsg', {
                        msg: Object.assign(Object.assign({}, msg), { needMsgReceipt: true }),
                        scene: /^p2p/.test(session) ? 'p2p' : 'team',
                        to: session.replace(/^p2p-|^team-/, ''),
                    }));
                    forwardedMsg.sessionId === msg.sessionId &&
                        dispatchMsg({
                            type: MessageAction.PUSH_MSG,
                            payload: {
                                msg: forwardedMsg,
                            },
                        });
                    return forwardedMsg;
                }));
            }));
        }
        else if (type === 'shareText') {
            const p2pReg = /^p2p-.*/;
            const teamReg = /^team-.*/;
            const p2pIds = checkedSessionMap.filter(item => p2pReg.test(item)).map(item => item.replace(/^p2p-|^team-/, ''));
            const teamIds = checkedSessionMap.filter(item => teamReg.test(item)).map(item => item.replace(/^p2p-|^team-/, ''));
            const currentInfo = systemApi.getCurrentUser();
            const currentContact = lodashGet(currentInfo, 'contact.contactInfo', []).find(item => item.contactItemType === 'yunxin');
            let userYunxinId = currentContact === null || currentContact === void 0 ? void 0 : currentContact.contactItemVal;
            if (!userYunxinId && (currentInfo === null || currentInfo === void 0 ? void 0 : currentInfo.id)) {
                const userInfo = await contactApi.doGetContactByItem({
                    type: 'EMAIL',
                    value: [currentInfo.id],
                });
                const userContact = lodashGet(userInfo, '0.contactInfo', []).find(item => item.contactItemType === 'yunxin');
                userYunxinId = userContact === null || userContact === void 0 ? void 0 : userContact.contactItemVal;
            }
            const params = {
                from: userYunxinId || '',
                tos: p2pIds,
                teamIds,
                emailTid: (_a = msgs) === null || _a === void 0 ? void 0 : _a.mailTid,
                emailMid: (_b = msgs) === null || _b === void 0 ? void 0 : _b.mailMid,
            };
            success = !!((_c = (await discussApi.shareMail(params))) === null || _c === void 0 ? void 0 : _c.success);
        }
        setConfirmloading(false);
        if (!success) {
            message.error(`${MODAL_TEXT[type].okText}失败，请检查网络`);
            return;
        }
        onVisibleChange(false);
        onForwardSuccess && onForwardSuccess();
        message.success({
            content: `${MODAL_TEXT[type].okText}成功`,
        });
    };
    return (React.createElement(Modal, { width: 600, visible: visible, className: realStyle('chatForwardModal'), title: React.createElement("p", { className: realStyle('headTitle') }, MODAL_TEXT[type].titleText), confirmLoading: confirmloading, onCancel: onCancel, footer: React.createElement(ChatForwardFooter, { okText: MODAL_TEXT[type].okText, onVisibleChange: onVisibleChange, sendForwardMsg: sendForwardMsg, loading: confirmloading, checkedSessionIds: checkedSessionMap, mailMid: (_a = msgs) === null || _a === void 0 ? void 0 : _a.mailMid }), closeIcon: React.createElement(CloseIcon, { className: "dark-invert" }), getContainer: () => document.body },
        React.createElement("div", { className: `${realStyle('modalContentWrapper')} chat-forward-modal-content-wrapper` },
            React.createElement(ChatForwardSessionList, { sessionList: $sessionlist, checkedSessionMap: checkedSessionMap, onChange: onChange }),
            React.createElement(CheckedSessionList, { checkedSessionMap: checkedSessionMap, onChange: onChange }))));
};
export default ChatForward;
